<div class="settings-card">
  <div class="card-header">
    <h4 class="card-title">Account Settings</h4>
    <p class="card-subtitle">Manage your account information and security settings</p>
  </div>

  <form [formGroup]="accountForm" (ngSubmit)="saveChanges()" class="account-form">
    <div class="form-grid">

      <!-- Email Address -->
      <div class="form-field">
        <label class="field-label">Email Address</label>
        <input pInputText formControlName="email" placeholder="Enter your email address" class="w-full"
          [class.ng-invalid]="isInvalid('email')" [class.ng-dirty]="isInvalid('email')" />
        @if (isInvalid('email')) {
        <small class="field-error">{{ getError('email') }}</small>
        }
      </div>

      <!-- Current Password -->
      <div class="form-field">
        <label class="field-label">Current Password</label>
        <p-password formControlName="currentPassword" placeholder="Enter current password" [feedback]="false"
          [toggleMask]="true" class="w-full" inputClass="w-full" [class.ng-invalid]="isInvalid('currentPassword')" />
        @if (isInvalid('currentPassword')) {
        <small class="field-error">{{ getError('currentPassword') }}</small>
        }
      </div>

      <!-- New Password -->
      <div class="form-field">
        <label class="field-label">New Password</label>
        <p-password formControlName="newPassword" placeholder="Enter new password" [feedback]="false"
          [toggleMask]="true" class="w-full" inputClass="w-full" [class.ng-invalid]="isInvalid('newPassword')" />
        @if (isInvalid('newPassword')) {
        <small class="field-error">{{ getError('newPassword') }}</small>
        }
      </div>

      <!-- Confirm New Password — NOW INSIDE the grid -->
      <div class="form-field">
        <label class="field-label">Confirm New Password</label>
        <p-password formControlName="confirmPassword" placeholder="Confirm new password" [feedback]="false"
          [toggleMask]="true" class="w-full" inputClass="w-full" [class.ng-invalid]="isInvalid('confirmPassword')" />
        @if (isInvalid('confirmPassword')) {
        <small class="field-error">{{ getError('confirmPassword') }}</small>
        }
      </div>

    </div>

    <!-- Actions -->
    <div class="form-actions mt-4">
      <p-button label="Save Changes" icon="pi pi-save" [loading]="saving" [disabled]="!formReady"
        (onClick)="saveChanges()" class="save-btn" />
      <button type="button" class="cancel-btn" (click)="cancelChanges()">Cancel</button>
    </div>
  </form>

  <!-- Security Section -->
  <!-- Security Section -->
  <div class="security-section mt-5">
    <h4 class="card-title mb-3">Security</h4>

    <div class="security-grid">

      <!-- 2FA teaser card -->
      <div class="security-card" (click)="toggle2FA()">
        <div>
          <p class="security-title">Two-Factor Authentication</p>
          <p class="security-desc">Add an extra layer of security</p>
        </div>
        <button type="button" class="security-arrow" [class.security-arrow-open]="show2FA()">
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>

      <!-- Active Sessions teaser card -->
      <div class="security-card" (click)="toggleSessions()">
        <div>
          <p class="security-title">Active Sessions</p>
          <p class="security-desc">Manage your active sessions</p>
        </div>
        <button type="button" class="security-arrow" [class.security-arrow-open]="showSessions()">
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>

    </div>

    <!-- 2FA expanded panel -->
    @if (show2FA()) {
    <div class="security-block mt-3">
      <h5 class="security-block-title">Two-Factor Authentication</h5>
      <p class="security-block-subtitle">Choose how you want to receive your OTP.</p>

    <div class="radio-list mt-3">
      <app-two-factor-auth
        [selected2FA]="selected2FA"
        (twoFAChange)="on2FAChange($event)">
      </app-two-factor-auth>
    </div>
    </div>
    }

    <!-- Active Sessions expanded panel -->
    @if (showSessions()) {
    <div class="security-block mt-3">
      <h5 class="security-block-title">Active Sessions</h5>
      <p class="security-block-subtitle">Manage your active sessions across devices.</p>

      <app-active-sessions
        [activeSessions]="activeSessions"
        (revoke)="confirmRevoke($event)">
      </app-active-sessions>
    </div>
    }
  </div>
</div>